import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface FeatureFlagsResponse {
  organization: number;
  flags: Record<string, boolean>;
  created_at: string;
  updated_at: string;
}

export interface FeatureFlagsRequest {
  flags: Record<string, boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/v1/organization/featureflags`;

  public getFlags(organizationId: number): Observable<FeatureFlagsResponse> {
    return this.http.get<FeatureFlagsResponse>(`${this.apiUrl}/${organizationId}/`);
  }

  public updateFlags(organizationId: number, flags: FeatureFlagsRequest): Observable<FeatureFlagsResponse> {
    return this.http.put<FeatureFlagsResponse>(`${this.apiUrl}/${organizationId}/`, flags);
  }
}
